/* Home page motion: fade up, hero zoom, stitch dividers, parallax, counting stats,
   tile tilt, Blueprint scan reveal, sticky shop bar.
   Does nothing when the visitor asks for reduced motion; content is visible without JS. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  if (reduce || !('IntersectionObserver' in window)) return;
  root.classList.add('uc-motion');

  function onView(els, cb, opts) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, opts || { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // 9. Fade up, staggered within each section
  var fadeSel = '.uc-eyebrow, .uc-h1, .uc-h2, .uc-p, .uc-btns, .uc-stars, .uc-tile, .uc-rev__card, .uc-gear__card, .uc-feat__list li, .uc-feat__media, .uc-promise__item, .uc-usa__badges, .uc-dealer, .uc-bpimg';
  $$('.uc').forEach(function (sec) {
    $$(fadeSel, sec).forEach(function (el, i) {
      if (el.parentElement.closest('.uc-dealer')) return;
      el.classList.add('uc-fade');
      el.style.transitionDelay = Math.min(i, 6) * 80 + 'ms';
    });
  });
  $$('[id$="__uc_products"] .grid__item').forEach(function (el, i) {
    el.classList.add('uc-fade'); el.style.transitionDelay = i * 90 + 'ms';
  });
  // The hero plays on page load (its buttons can start just below the fold); everything else on scroll
  var heroFades = $$('.uc-hero .uc-fade');
  requestAnimationFrame(function () { requestAnimationFrame(function () { heroFades.forEach(function (el) { el.classList.add('is-in'); }); }); });
  onView($$('.uc-fade').filter(function (el) { return heroFades.indexOf(el) < 0; }), function (el) { el.classList.add('is-in'); });

  // 10. Hero slow push-in (CSS), started once the image has loaded
  var hero = document.querySelector('.uc-hero');
  if (hero) {
    var himg = hero.querySelector('img');
    var go = function () { hero.classList.add('is-live'); };
    if (!himg || himg.complete) go(); else { himg.addEventListener('load', go); setTimeout(go, 1500); }
  }

  // 11. Copper stitch line that sews itself in above key sections
  ['uc_tiles', 'uc_leather', 'uc_reviews', 'uc_gear'].forEach(function (id) {
    var s = document.querySelector('[id$="__' + id + '"]');
    if (!s) return;
    var d = document.createElement('div');
    d.className = 'uc-stitch'; d.setAttribute('aria-hidden', 'true');
    d.innerHTML = '<span></span>';
    s.insertBefore(d, s.firstChild);
  });
  onView($$('.uc-stitch'), function (el) { el.classList.add('is-in'); }, { threshold: 0.6 });

  // 12. Parallax on background photos (desktop only, cheap: one rAF per scroll)
  var par = $$('.uc-usa__img, .uc-featbg__img');
  if (par.length && window.matchMedia('(min-width:750px)').matches) {
    var ticking = false;
    var run = function () {
      ticking = false;
      var vh = window.innerHeight;
      par.forEach(function (el) {
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var p = (box.top + box.height / 2 - vh / 2) / vh; // -1..1 around the middle of the screen
        el.style.transform = 'translate3d(0,' + (p * -40).toFixed(1) + 'px,0)';
      });
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  // 13. Count up numbers like "30,000+" and "3,300+"
  $$('.uc-stars span, .uc-feat__list li').forEach(function (el) {
    if (!/\d[\d,]*\+/.test(el.textContent)) return;
    el.innerHTML = el.innerHTML.replace(/(\d[\d,]*)\+/, function (m, n) {
      return '<span class="uc-count" data-to="' + n.replace(/,/g, '') + '">' + n + '</span>+';
    });
  });
  // Never shows "0+": the hero keeps its real number (it is on screen at load, and a paused tab or a
  // screenshot froze it at 0, RC check 26 Oct 2026); elsewhere it counts from 80% and ends exact.
  onView($$('.uc-count').filter(function (el) { return !el.closest('.uc-hero'); }), function (el) {
    var to = +el.getAttribute('data-to'), from = Math.round(to * 0.8), t0 = null, dur = 1200;
    var fmt = function (v) { return Math.round(v).toLocaleString('en-US'); };
    var step = function (t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      el.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    };
    el.textContent = fmt(from);
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = fmt(to); }, dur + 400);
  }, { threshold: 0.6 });

  // 15. Carry style tiles tilt toward the cursor (mouse only)
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    $$('.uc-tile').forEach(function (tile) {
      tile.addEventListener('mousemove', function (e) {
        var r = tile.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        tile.style.transform = 'perspective(900px) rotateX(' + (y * -6).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg) translateY(-4px)';
      });
      tile.addEventListener('mouseleave', function () { tile.style.transform = ''; });
    });
  }

  // 16. Blueprint banner: scan line sweeps across and reveals it
  onView($$('.uc-bpimg, .uc-bp'), function (el) { el.classList.add('is-scan'); }, { threshold: 0.35 });

  // 18. Sticky shop bar: shows after the hero, hides near the dealer section and footer
  var bar = document.createElement('div');
  bar.className = 'uc-sticky'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Quick shop');
  bar.innerHTML = '<a href="#gunmatch" class="uc-sticky__gm">Find my holster</a><a href="/#carry-style" class="uc-sticky__shop">Shop holsters</a>';
  document.body.appendChild(bar);
  bar.querySelector('.uc-sticky__gm').addEventListener('click', function (e) {
    var gm = document.getElementById('gunmatch'), q = document.getElementById('q');
    if (!gm) return;
    e.preventDefault();
    // Focus inside the tap itself so phones open the keyboard and show the cursor, then scroll
    if (q) { try { q.focus({ preventScroll: true }); } catch (x) { q.focus(); } }
    gm.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  var past = false, near = false;
  var sync = function () { bar.classList.toggle('is-on', past && !near); };
  var top = document.querySelector('.uc-hero') || document.getElementById('gunmatch');
  if (top) new IntersectionObserver(function (e) { past = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; sync(); }).observe(top);
  var end = document.querySelector('.uc-dealer') || document.querySelector('footer');
  if (end) new IntersectionObserver(function (e) { near = e[0].isIntersecting; sync(); }).observe(end);
})();
